import styled, { css } from 'styled-components';

import { ALERT_STYLE } from './types';

interface IAlertBoxProps {
  alertStyle: ALERT_STYLE;
}

export const AlertBox = styled.div<IAlertBoxProps>`
  margin-bottom: 1.35rem;
  padding: 0.5rem 1.6rem;
  font-size: 1rem;
  font-weight: ${Styles.fontWeight.heavy};
  text-align: center;
  border: 1px solid ${Styles.color.primary};
  color: ${Styles.color.primary};

  a {
    color: ${Styles.color.primary};
  }

  ${({ alertStyle }) =>
    alertStyle === ALERT_STYLE.error &&
    css`
      border: 1px solid ${Styles.color.grey.eight};
      color: ${Styles.color.black};
      font-weight: ${Styles.fontWeight.normal};

      a {
        color: ${Styles.color.grey.eight};
      }
    `}
`;
